import request from '../utils/request'

export function departmentOfHospital (hospitalId) {
  return request.get(`/da/departmentOfHospital/${hospitalId}`)
}

export function doctorScheduleOfDepartment (departmentId) {
  return request.get(`/da/doctorScheduleOfDepartment/${departmentId}`)
}

export function orderPrepare (doctorScheduleId, timeRangeIndex) {
  return request.get(`/da/orderPrepare/${doctorScheduleId}/${timeRangeIndex}`)
}

export function orderCreate (doctorScheduleId, timeRangeIndex, orderFrom, data) {
  return request.post(`/da/orderCreate/${doctorScheduleId}/${timeRangeIndex}/${orderFrom}`, data)
}

export function orderCancel (orderId) {
  return request.post('/da/orderCancel', { id: orderId })
}

export function orderDelete (orderId) {
  return request.post('/da/orderDelete', { id: orderId })
}

/*
 * 返回order对象，Doctor，Hospital，科室，时间段，等信息
 */
export function orderDetail (orderId) {
  return request.get(`/da/orderDetail/${orderId}`)
}

export function orderList (hospitalId) {
  return request.get(`/da/orderList`, {
    h: hospitalId
  })
}

/*
 * 只返回order对象本身
 */
export function orderGet (orderId) {
  return request.get(`/da/order/${orderId}`)
}
/*
 * 只返回对象本身
 */
export function doctorGet (doctorId) {
  return request.get(`/da/doctor/${doctorId}`)
}
/*
 * 只返回对象本身
 */
export function departmentGet (departmentId) {
  return request.get(`/da/department/${departmentId}`)
}
/*
 * 只返回对象本身
 */
export function hospitalGet (hospitalId) {
  return request.get(`/da/hospital/${hospitalId}`)
}
